import React from "react";
import "../styles/styles.css";

function BlogPage() {
  const blogPosts = [
    {
      title: "Simplifica la gestión de tus documentos con nuestros servicios digitales",
      date: "Enero 09, 2025",
      excerpt: "Cansado de perder tiempo organizando y procesando documentos? En Cybersofía, te ayudamos con servicios como impresión en línea, redacción de contratos y organización de PDFs. Descubre cómo optimizar tus tareas diarias con nuestras soluciones rápidas, confiables y al alcance de un clic. 🌐 Explora nuestras guías y consejos para maximizar tu productividad.",
      image: "/files/img/blog1.png",
    },
    {
      title: "Contratos y trámites hechos fáciles: Guía completa para tu tranquilidad",
      date: "Enero 09, 2025",
      excerpt: "Redactar contratos o resolver trámites puede ser abrumador. En nuestro blog de Cybersofía, te mostramos cómo gestionar contratos de compraventa, alquiler y más con soluciones personalizadas y claras. 📄 Conoce los secretos para agilizar tus procesos legales y mejorar tu experiencia con trámites digitales.",
      image: "/files/img/blog2.png",
    },
    {
      title: "Innovación en servicios digitales: La clave para ahorrar tiempo y esfuerzo",
      date: "Enero 09, 2025",
      excerpt: "La digitalización es la clave para simplificar tu vida. Desde impresiones a color hasta consultas rápidas de tu información personal como el RUT o datos crediticios, Cybersofía2025 te ofrece herramientas diseñadas para resultados rápidos y efectivos. 💡 Lee nuestros artículos sobre cómo la tecnología puede transformar tus trámites diarios.",
      image: "/files/img/blog3.png",
    },
  ];

  return (
    <div className="blog-page">
      <h1 className="blog-title">Nuestro Blog</h1>
      <div className="blog-container">
        {blogPosts.map((post, index) => (
          <div className="blog-post" key={index}>
            <img src={post.image} alt={post.title} className="blog-image" />
            <div className="blog-content">
              <h2 className="blog-post-title">{post.title}</h2>
              <p className="blog-post-date">{post.date}</p>
              <p className="blog-post-excerpt">{post.excerpt}</p>
              <button className="blog-read-more">Leer más</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BlogPage;
